function DataEx2(){
     

    return(
        <div className="div">
          <h1>Als je kijkt naar de partijen op basis van leeftijd dan vallen twee partijen op. GroenLinks focust zich vooral op personen tussen de 18 en 30, DENK focust zich vooral op personen tussen de 30 en de 50 en 50PLUS vooral op 50+’ers.</h1>
        </div>
    )
}

export default DataEx2

